/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_ConfirmInputs */

const en_settings_billing_cancel_confirm = /** @type {(inputs: Settings_Billing_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

const zh_settings_billing_cancel_confirm = /** @type {(inputs: Settings_Billing_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认取消`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Settings_Billing_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_confirm = /** @type {((inputs?: Settings_Billing_Cancel_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_cancel_confirm(inputs)
	return zh_settings_billing_cancel_confirm(inputs)
});
export { settings_billing_cancel_confirm as "settings.billing.cancel_confirm" }